import { Component, Input, OnInit } from '@angular/core';
import PKT from '../../../../../package.json';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
})
export class HomeComponent {
  @Input() buttons!: any[];
  @Input() tradinSystemName!: string;
  constructor() {}
  get appVersion() {
    return PKT.version;
  }
}
